// AUTO-GENERATED from the Tree-of-Thoughts 24.csv (a mirror of 4nums.com human
// difficulty rankings): 1362 solvable Game-of-24 puzzles using numbers 1-13,
// ranked 1 = easiest … 1362 = hardest, from ~7M real solve attempts. The rank
// is the human-validated difficulty; solveRate is the % of players who solved it.
// Do not edit by hand — regenerate from the source CSV.

// [ four numbers, human rank (1=easiest), solve-rate % ]
export const HUMAN_PUZZLES: ReadonlyArray<readonly [number[], number, number]> = [
  [[1,1,4,6], 1, 99.2],
  [[1,1,11,11], 2, 99.6],
  [[1,1,3,8], 3, 99.2],
  [[1,1,1,8], 4, 98.8],
  [[6,6,6,6], 5, 99.4],
  [[1,1,2,12], 6, 99.1],
  [[1,2,2,6], 7, 99.2],
  [[1,1,10,12], 8, 99],
  [[2,2,10,10], 9, 98.2],
  [[1,1,1,12], 10, 99.2],
  [[1,1,2,8], 11, 97.8],
  [[1,1,4,8], 12, 98.1],
  [[1,1,5,8], 13, 96.4],
  [[4,6,11,11], 14, 98.9],
  [[1,1,3,12], 15, 97.3],
  [[2,2,2,12], 16, 99.1],
  [[1,1,4,12], 17, 97.4],
  [[1,1,12,12], 18, 99.4],
  [[3,3,3,8], 19, 98],
  [[1,1,2,6], 20, 98.4],
  [[1,1,2,11], 21, 98.9],
  [[1,2,3,4], 22, 99],
  [[11,11,12,12], 23, 98.7],
  [[3,7,7,8], 24, 96.7],
  [[1,1,13,13], 25, 99.3],
  [[1,2,4,12], 26, 97.6],
  [[1,1,3,6], 27, 97.7],
  [[1,1,3,9], 28, 97],
  [[7,7,12,12], 29, 98.6],
  [[4,6,7,7], 30, 98.6],
  [[1,1,2,13], 31, 98.7],
  [[1,1,5,6], 32, 96.8],
  [[1,1,11,13], 33, 99.1],
  [[1,6,6,12], 34, 98.7],
  [[4,5,12,12], 35, 97],
  [[4,6,13,13], 36, 98.7],
  [[12,12,12,12], 37, 99.3],
  [[2,11,11,12], 38, 97.2],
  [[4,4,4,6], 39, 98.1],
  [[1,1,1,11], 40, 97.3],
  [[1,1,11,12], 41, 99.3],
  [[2,7,7,12], 42, 98.7],
  [[1,5,7,12], 43, 98.3],
  [[10,10,12,12], 44, 98.6],
  [[1,8,8,8], 45, 97.7],
  [[2,2,3,8], 46, 98.1],
  [[2,9,9,12], 47, 97.3],
  [[11,11,11,12], 48, 94.8],
  [[3,8,13,13], 49, 94.8],
  [[9,9,12,12], 50, 98.3],
  [[1,1,5,5], 51, 99.1],
  [[3,3,12,12], 52, 98.7],
  [[1,1,4,5], 53, 97.8],
  [[1,6,8,12], 54, 96.8],
  [[8,8,12,12], 55, 98.5],
  [[3,8,11,11], 56, 96],
  [[5,6,12,12], 57, 97.1],
  [[11,12,12,12], 58, 97.6],
  [[12,12,13,13], 59, 98.6],
  [[1,1,12,13], 60, 98.7],
  [[1,3,5,12], 61, 96.4],
  [[5,5,12,12], 62, 98.7],
  [[1,9,9,12], 63, 95.5],
  [[2,3,3,12], 64, 98.6],
  [[3,4,4,8], 65, 98.3],
  [[3,8,10,10], 66, 95.6],
  [[3,8,9,9], 67, 97],
  [[2,5,5,12], 68, 98.7],
  [[11,11,11,13], 69, 98.4],
  [[2,12,13,13], 70, 97.1],
  [[7,7,11,12], 71, 93.7],
  [[1,1,3,7], 72, 96.8],
  [[1,4,10,10], 73, 97.9],
  [[4,4,12,12], 74, 98.6],
  [[1,3,4,12], 75, 98.5],
  [[5,5,11,12], 76, 96.5],
  [[1,2,5,8], 77, 95.5],
  [[2,2,4,6], 78, 99],
  [[1,6,7,12], 79, 98.5],
  [[1,8,9,12], 80, 96.5],
  [[6,7,12,12], 81, 95.6],
  [[1,3,10,10], 82, 97.4],
  [[2,3,3,8], 83, 96.9],
  [[3,5,5,8], 84, 96.9],
  [[1,1,1,13], 85, 97.4],
  [[2,3,12,12], 86, 97.4],
  [[1,4,7,12], 87, 98.3],
  [[8,8,11,13], 88, 97],
  [[1,3,3,4], 89, 97.4],
  [[1,8,8,12], 90, 96.3],
  [[3,7,8,8], 91, 95.9],
  [[7,8,12,12], 92, 96.1],
  [[9,9,11,12], 93, 93.9],
  [[1,2,5,12], 94, 95.4],
  [[2,7,7,8], 95, 96.8],
  [[4,4,11,13], 96, 97.9],
  [[1,1,4,7], 97, 97.1],
  [[1,1,10,13], 98, 97.9],
  [[4,6,6,6], 99, 98.3],
  [[5,5,7,7], 100, 97.8],
  [[4,5,11,12], 101, 97.4],
  [[1,6,9,12], 102, 95.4],
  [[1,7,9,12], 103, 95.9],
  [[2,2,12,12], 104, 98.7],
  [[1,1,2,10], 105, 95.6],
  [[3,7,7,7], 106, 97.4],
  [[1,7,7,10], 107, 97.8],
  [[4,5,5,6], 108, 97.3],
  [[4,8,11,11], 109, 95.1],
  [[1,2,2,10], 110, 96.6],
  [[1,6,6,11], 111, 98.2],
  [[3,3,4,6], 112, 97.7],
  [[4,4,11,12], 113, 91.9],
  [[2,2,2,3], 114, 99],
  [[3,3,11,12], 115, 94.7],
  [[3,6,11,11], 116, 94.4],
  [[3,8,8,8], 117, 97.5],
  [[12,12,12,13], 118, 97.4],
  [[1,2,2,12], 119, 97.7],
  [[2,8,9,9], 120, 96.3],
  [[6,6,12,12], 121, 98.4],
  [[8,9,12,12], 122, 96.2],
  [[1,5,8,8], 123, 94.8],
  [[2,2,3,12], 124, 98],
  [[3,4,4,6], 125, 97.4],
  [[1,5,6,12], 126, 98.5],
  [[4,6,9,9], 127, 96.3],
  [[6,6,11,13], 128, 97.8],
  [[7,7,11,13], 129, 97.4],
  [[1,4,4,12], 130, 95.6],
  [[1,4,6,12], 131, 96.6],
  [[9,9,11,13], 132, 96.8],
  [[3,8,12,13], 133, 96],
  [[1,8,10,12], 134, 95.6],
  [[3,4,11,13], 135, 96.4],
  [[11,13,13,13], 136, 97.8],
  [[4,6,6,7], 137, 96.4],
  [[1,3,6,12], 138, 96.8],
  [[2,4,4,12], 139, 98.4],
  [[3,6,7,7], 140, 93.3],
  [[4,6,8,8], 141, 96.8],
  [[1,4,5,12], 142, 95.7],
  [[10,11,12,12], 143, 95.9],
  [[2,4,11,11], 144, 96.2],
  [[4,6,10,11], 145, 94.5],
  [[4,8,10,10], 146, 97.5],
  [[1,4,8,12], 147, 97.5],
  [[2,10,10,12], 148, 97],
  [[3,6,13,13], 149, 94.5],
  [[5,6,11,12], 150, 97.2],
  [[6,6,10,13], 151, 93.7],
  [[10,10,11,13], 152, 97.6],
  [[1,3,3,12], 153, 95.3],
  [[1,7,8,9], 154, 97.1],
  [[1,12,13,13], 155, 94.3],
  [[3,8,10,11], 156, 94.4],
  [[9,10,12,12], 157, 95.7],
  [[1,11,11,12], 158, 93.4],
  [[4,5,12,13], 159, 97.6],
  [[1,3,6,8], 160, 95.4],
  [[1,2,11,11], 161, 97.3],
  [[1,6,12,12], 162, 94.5],
  [[2,8,8,12], 163, 97.4],
  [[3,6,6,8], 164, 97],
  [[5,5,5,5], 165, 95.2],
  [[3,7,10,10], 166, 97.3],
  [[2,8,10,10], 167, 95.3],
  [[4,6,10,10], 168, 96.3],
  [[1,1,3,13], 169, 95.1],
  [[1,2,6,6], 170, 97.4],
  [[1,6,7,10], 171, 98.5],
  [[1,2,4,4], 172, 97.1],
  [[1,7,8,10], 173, 97.5],
  [[4,5,5,5], 174, 97.4],
  [[1,1,4,4], 175, 94.5],
  [[1,2,6,12], 176, 96.8],
  [[1,5,8,12], 177, 98.1],
  [[1,2,10,12], 178, 97.4],
  [[1,5,7,11], 179, 98.5],
  [[1,10,10,12], 180, 92.3],
  [[3,8,12,12], 181, 96.5],
  [[2,2,11,13], 182, 98],
  [[3,9,9,9], 183, 97.6],
  [[1,1,6,6], 184, 97.2],
  [[1,2,4,8], 185, 96.5],
  [[1,6,8,9], 186, 98.2],
  [[3,4,12,12], 187, 94.5],
  [[4,8,13,13], 188, 94.4],
  [[1,1,3,4], 189, 98],
  [[1,3,9,12], 190, 96.2],
  [[3,8,11,12], 191, 94.2],
  [[1,1,9,13], 192, 97.2],
  [[1,2,6,8], 193, 95.9],
  [[1,7,8,8], 194, 96.6],
  [[2,8,13,13], 195, 90.2],
  [[2,11,11,11], 196, 90],
  [[2,11,12,12], 197, 95.4],
  [[4,7,7,8], 198, 93.8],
  [[3,3,4,8], 199, 96.2],
  [[2,2,11,12], 200, 92.3],
  [[5,6,12,13], 201, 97.4],
  [[3,3,11,13], 202, 96.9],
  [[4,7,12,12], 203, 88.5],
  [[2,13,13,13], 204, 91.1],
  [[5,5,12,13], 205, 95.6],
  [[10,13,13,13], 206, 93.2],
  [[1,7,7,12], 207, 88.9],
  [[2,3,11,12], 208, 94.8],
  [[5,5,11,13], 209, 96.1],
  [[1,2,3,10], 210, 98.4],
  [[1,5,5,12], 211, 90.5],
  [[1,5,7,13], 212, 97.9],
  [[3,3,3,6], 213, 97.7],
  [[3,3,3,12], 214, 96.9],
  [[10,10,11,12], 215, 93.3],
  [[1,4,7,8], 216, 96.6],
  [[1,10,12,12], 217, 95.8],
  [[8,8,11,12], 218, 90.6],
  [[1,2,3,8], 219, 97],
  [[4,4,10,13], 220, 93.5],
  [[1,4,6,8], 221, 94.4],
  [[2,2,4,5], 222, 98.3],
  [[11,12,13,13], 223, 95.1],
  [[1,2,2,8], 224, 93.3],
  [[5,5,5,6], 225, 96.1],
  [[1,1,5,7], 226, 96.4],
  [[1,2,13,13], 227, 97.2],
  [[7,7,12,13], 228, 93.9],
  [[1,4,8,8], 229, 96.5],
  [[3,11,11,12], 230, 91.4],
  [[1,2,3,12], 231, 96.2],
  [[1,3,8,9], 232, 92.2],
  [[1,3,11,11], 233, 97.2],
  [[1,4,4,5], 234, 96.9],
  [[1,5,10,10], 235, 97.3],
  [[1,8,10,13], 236, 94.8],
  [[2,2,2,8], 237, 96.4],
  [[1,4,12,12], 238, 91.2],
  [[2,7,8,12], 239, 94.9],
  [[4,4,5,6], 240, 95.7],
  [[7,9,11,11], 241, 95.8],
  [[2,12,12,13], 242, 95.5],
  [[6,7,11,12], 243, 96.8],
  [[4,6,12,13], 244, 93.8],
  [[1,2,10,11], 245, 97.6],
  [[1,5,8,9], 246, 93.9],
  [[1,5,7,8], 247, 94.7],
  [[4,8,9,9], 248, 90.4],
  [[9,9,12,13], 249, 94],
  [[8,8,8,10], 250, 90.4],
  [[2,12,12,12], 251, 98.4],
  [[1,8,8,9], 252, 96.3],
  [[2,8,11,11], 253, 88.5],
  [[4,5,13,13], 254, 87.7],
  [[1,2,12,12], 255, 95.8],
  [[2,8,10,11], 256, 94.7],
  [[2,11,13,13], 257, 94.1],
  [[1,6,7,11], 258, 97.4],
  [[3,6,7,8], 259, 97.8],
  [[1,2,8,8], 260, 96.1],
  [[4,5,9,9], 261, 88.4],
  [[1,3,3,7], 262, 95.9],
  [[2,5,6,12], 263, 95.1],
  [[3,6,10,11], 264, 95.8],
  [[1,3,6,6], 265, 97.2],
  [[1,6,6,13], 266, 97.2],
  [[4,4,4,4], 267, 97.8],
  [[10,10,10,13], 268, 92.9],
  [[1,6,9,9], 269, 97.5],
  [[2,6,6,12], 270, 97.7],
  [[3,7,9,9], 271, 91],
  [[1,7,8,12], 272, 95.6],
  [[3,12,13,13], 273, 91],
  [[6,6,11,12], 274, 88.9],
  [[1,3,5,8], 275, 95.1],
  [[6,10,10,10], 276, 95.7],
  [[2,3,11,13], 277, 91.9],
  [[1,1,3,11], 278, 94.3],
  [[1,4,4,7], 279, 96.1],
  [[1,2,4,6], 280, 95.9],
  [[1,9,12,12], 281, 92.6],
  [[3,4,5,8], 282, 96.1],
  [[4,5,6,6], 283, 95.3],
  [[1,3,3,5], 284, 95.1],
  [[1,4,6,13], 285, 97.5],
  [[2,2,2,11], 286, 92.1],
  [[2,4,5,12], 287, 94.5],
  [[10,11,11,13], 288, 94.7],
  [[12,13,13,13], 289, 94.3],
  [[3,7,11,11], 290, 88],
  [[3,7,13,13], 291, 87.3],
  [[4,6,7,8], 292, 95.8],
  [[1,4,7,13], 293, 96.5],
  [[1,5,8,10], 294, 96.3],
  [[5,6,6,7], 295, 97.9],
  [[1,5,10,12], 296, 92],
  [[1,6,8,10], 297, 97.1],
  [[3,5,11,11], 298, 94.5],
  [[3,9,9,12], 299, 94.7],
  [[2,10,11,12], 300, 95.9],
  [[2,8,8,13], 301, 92.8],
  [[7,8,11,12], 302, 96.2],
  [[1,2,5,6], 303, 94.6],
  [[1,7,7,11], 304, 96.8],
  [[4,6,12,12], 305, 96.8],
  [[1,3,13,13], 306, 97],
  [[3,8,9,10], 307, 96.2],
  [[3,10,10,12], 308, 94.2],
  [[4,4,12,13], 309, 92],
  [[1,10,11,12], 310, 94.6],
  [[2,3,4,6], 311, 97.8],
  [[4,6,11,12], 312, 92.8],
  [[1,2,10,13], 313, 97],
  [[1,3,3,9], 314, 96.7],
  [[1,9,11,12], 315, 93.7],
  [[2,2,8,12], 316, 98],
  [[2,5,6,11], 317, 96.3],
  [[3,4,10,13], 318, 96.5],
  [[3,7,7,12], 319, 89.9],
  [[1,2,3,6], 320, 97],
  [[3,6,6,7], 321, 93.6],
  [[1,12,12,12], 322, 93.4],
  [[2,8,9,12], 323, 95],
  [[3,3,3,3], 324, 96],
  [[1,4,8,13], 325, 97.4],
  [[4,4,5,5], 326, 93.2],
  [[6,7,12,13], 327, 95.4],
  [[1,2,5,5], 328, 95.1],
  [[2,2,5,5], 329, 93.2],
  [[5,6,7,7], 330, 87.8],
  [[5,7,10,12], 331, 96.7],
  [[1,1,6,12], 332, 91.1],
  [[1,3,3,3], 333, 95.5],
  [[4,5,11,11], 334, 87.2],
  [[1,1,2,7], 335, 95.4],
  [[1,2,5,7], 336, 95],
  [[1,5,6,6], 337, 93.6],
  [[9,9,10,13], 338, 90.9],
  [[1,6,6,10], 339, 93.6],
  [[3,3,12,13], 340, 93.3],
  [[6,8,10,12], 341, 97.2],
  [[2,2,2,13], 342, 93.4],
  [[2,3,12,13], 343, 95.9],
  [[3,3,5,6], 344, 96.2],
  [[2,11,11,13], 345, 94.9],
  [[4,5,7,7], 346, 91.2],
  [[7,7,10,13], 347, 89.6],
  [[1,2,11,13], 348, 93.5],
  [[11,12,12,13], 349, 97],
  [[5,7,11,11], 350, 96.1],
  [[2,2,2,4], 351, 95.9],
  [[3,4,5,7], 352, 96.6],
  [[4,7,13,13], 353, 87.7],
  [[4,8,8,8], 354, 94.6],
  [[5,6,13,13], 355, 86.9],
  [[8,9,11,12], 356, 95.2],
  [[1,1,2,9], 357, 94.6],
  [[2,4,4,8], 358, 96.4],
  [[4,4,4,8], 359, 96.3],
  [[2,4,13,13], 360, 95.6],
  [[4,7,7,7], 361, 88.8],
  [[7,9,13,13], 362, 96.3],
  [[9,11,11,11], 363, 95.3],
  [[1,6,8,11], 364, 97.7],
  [[1,1,3,5], 365, 95.2],
  [[2,6,6,8], 366, 95.5],
  [[1,3,4,4], 367, 93.1],
  [[1,3,10,11], 368, 96.4],
  [[1,9,10,12], 369, 93.7],
  [[7,8,12,13], 370, 96.4],
  [[8,9,10,13], 371, 95.8],
  [[1,1,4,9], 372, 93.4],
  [[2,5,5,8], 373, 88],
  [[6,9,12,12], 374, 89.1],
  [[2,5,5,13], 375, 92],
  [[2,8,12,12], 376, 95],
  [[4,7,10,11], 377, 97],
  [[1,11,12,12], 378, 94.2],
  [[3,3,3,7], 379, 92.2],
  [[3,3,3,10], 380, 94.3],
  [[6,8,11,11], 381, 94.2],
  [[9,10,11,12], 382, 96.1],
  [[1,3,6,7], 383, 96],
  [[8,9,12,13], 384, 96],
  [[1,2,2,11], 385, 97.1],
  [[1,8,8,11], 386, 93.3],
  [[4,5,10,10], 387, 91],
  [[1,2,11,12], 388, 96.9],
  [[2,4,5,8], 389, 95],
  [[2,5,12,12], 390, 83.2],
  [[3,6,6,12], 391, 95.4],
  [[4,6,9,10], 392, 93.5],
  [[4,7,8,8], 393, 94],
  [[5,5,10,10], 394, 86.7],
  [[1,2,7,10], 395, 90.9],
  [[2,6,10,12], 396, 95.1],
  [[2,6,7,13], 397, 96.6],
  [[2,9,9,11], 398, 87.3],
  [[8,8,10,13], 399, 90.4],
  [[1,1,8,8], 400, 89.5],
  [[2,2,10,13], 401, 90.1],
  [[2,2,12,13], 402, 92.1],
  [[5,6,11,11], 403, 87.2],
  [[11,11,12,13], 404, 94.9],
  [[1,2,6,7], 405, 95.1],
  [[3,8,8,9], 406, 95.5],
  [[6,7,10,13], 407, 96.4],
  [[9,12,12,12], 408, 82.2],
  [[1,6,8,8], 409, 93],
  [[4,4,4,12], 410, 96.6],
  [[5,5,10,13], 411, 89.7],
  [[6,8,8,8], 412, 88.1],
  [[5,6,9,9], 413, 90.6],
  [[1,3,7,13], 414, 96.8],
  [[1,7,8,11], 415, 92.6],
  [[3,6,9,9], 416, 94],
  [[5,5,6,6], 417, 93.1],
  [[5,5,13,13], 418, 85.5],
  [[1,3,5,13], 419, 94.1],
  [[1,8,8,10], 420, 92.4],
  [[2,9,9,13], 421, 88.6],
  [[1,7,7,9], 422, 96.3],
  [[3,7,12,13], 423, 93.8],
  [[8,8,9,11], 424, 89.7],
  [[4,8,11,12], 425, 92.9],
  [[1,7,10,12], 426, 92.6],
  [[2,3,5,5], 427, 96.2],
  [[2,6,7,12], 428, 92],
  [[8,8,12,13], 429, 92.1],
  [[8,10,11,11], 430, 94.8],
  [[3,5,5,6], 431, 89.1],
  [[1,3,10,12], 432, 96.4],
  [[2,3,3,13], 433, 94],
  [[5,5,11,11], 434, 85.8],
  [[1,2,2,13], 435, 96.4],
  [[2,5,9,12], 436, 95.4],
  [[3,3,4,4], 437, 94.4],
  [[1,2,3,5], 438, 95.4],
  [[1,3,9,11], 439, 95.1],
  [[2,2,7,13], 440, 96.1],
  [[1,5,6,9], 441, 91.9],
  [[2,6,10,10], 442, 95.7],
  [[10,10,12,13], 443, 92.2],
  [[1,10,12,13], 444, 94.3],
  [[2,8,8,8], 445, 93.9],
  [[3,4,11,12], 446, 95.1],
  [[1,2,4,10], 447, 96.2],
  [[4,7,12,13], 448, 92.4],
  [[7,8,8,9], 449, 86.6],
  [[1,3,4,11], 450, 96],
  [[4,6,6,8], 451, 97.3],
  [[6,6,6,11], 452, 88.7],
  [[3,8,8,12], 453, 91.5],
  [[2,7,7,13], 454, 86],
  [[2,9,10,12], 455, 93.8],
  [[3,7,11,12], 456, 90.6],
  [[4,5,11,13], 457, 90.3],
  [[6,6,12,13], 458, 90.3],
  [[1,5,9,9], 459, 94.4],
  [[3,4,5,12], 460, 97],
  [[5,6,11,13], 461, 91.7],
  [[1,12,12,13], 462, 94.2],
  [[4,8,10,12], 463, 95.7],
  [[5,9,10,10], 464, 92.8],
  [[3,6,11,12], 465, 93.4],
  [[2,6,7,9], 466, 96],
  [[3,5,13,13], 467, 94.3],
  [[3,7,7,9], 468, 86.6],
  [[1,3,4,5], 469, 97.5],
  [[3,9,10,11], 470, 93],
  [[1,3,7,8], 471, 89.3],
  [[1,7,9,13], 472, 93.7],
  [[1,8,11,12], 473, 91.5],
  [[4,7,11,11], 474, 86.3],
  [[1,6,6,9], 475, 90.3],
  [[5,5,7,8], 476, 92.4],
  [[7,9,10,12], 477, 94],
  [[1,6,8,13], 478, 94.3],
  [[3,4,8,10], 479, 93.4],
  [[5,10,11,11], 480, 90.3],
  [[2,4,10,12], 481, 96.5],
  [[4,5,5,8], 482, 88],
  [[10,12,12,13], 483, 90.1],
  [[1,1,6,8], 484, 94.9],
  [[2,2,3,9], 485, 94.5],
  [[3,3,4,5], 486, 94],
  [[5,8,8,10], 487, 91.4],
  [[1,8,9,11], 488, 92.6],
  [[2,3,3,11], 489, 89.3],
  [[2,7,8,13], 490, 94],
  [[3,5,5,12], 491, 89],
  [[5,5,9,9], 492, 85.5],
  [[7,10,10,11], 493, 93.5],
  [[10,11,11,12], 494, 96.7],
  [[2,5,6,8], 495, 95.6],
  [[3,3,9,9], 496, 95.9],
  [[3,6,6,6], 497, 94.4],
  [[5,8,12,12], 498, 75.9],
  [[2,3,7,12], 499, 94.7],
  [[5,6,8,8], 500, 92.2],
  [[1,11,12,13], 501, 93.8],
  [[3,5,6,8], 502, 93.5],
  [[6,8,13,13], 503, 93.3],
  [[4,4,5,8], 504, 95.9],
  [[7,10,12,12], 505, 84.6],
  [[1,8,9,13], 506, 91.4],
  [[3,5,10,12], 507, 94.8],
  [[3,9,11,11], 508, 85.8],
  [[6,6,6,9], 509, 89.6],
  [[5,5,10,11], 510, 87.7],
  [[2,2,4,7], 511, 95.3],
  [[3,6,8,8], 512, 92.7],
  [[3,9,13,13], 513, 86.3],
  [[4,4,4,7], 514, 91.1],
  [[1,4,4,4], 515, 95.7],
  [[9,10,10,13], 516, 95.2],
  [[2,10,10,11], 517, 85.2],
  [[3,3,10,13], 518, 89.4],
  [[1,2,3,9], 519, 96.4],
  [[2,4,8,10], 520, 97.8],
  [[1,7,9,9], 521, 94.7],
  [[2,6,6,6], 522, 95.9],
  [[2,6,9,11], 523, 95.5],
  [[3,4,4,7], 524, 90.3],
  [[2,6,6,13], 525, 84.9],
  [[8,8,8,12], 526, 88.2],
  [[3,5,5,7], 527, 89.9],
  [[4,7,9,9], 528, 86.4],
  [[5,7,13,13], 529, 94.2],
  [[1,4,5,5], 530, 95.8],
  [[1,5,5,6], 531, 94.9],
  [[4,8,12,13], 532, 91.7],
  [[5,10,13,13], 533, 92.5],
  [[2,10,10,13], 534, 90],
  [[3,3,5,5], 535, 89.4],
  [[3,7,9,10], 536, 91.9],
  [[1,2,3,7], 537, 96.1],
  [[4,4,7,9], 538, 93.2],
  [[2,2,6,6], 539, 95.8],
  [[2,6,6,11], 540, 83.2],
  [[6,7,11,13], 541, 90.1],
  [[1,2,2,4], 542, 95.5],
  [[3,5,6,12], 543, 93.4],
  [[2,2,7,8], 544, 93.7],
  [[2,4,4,13], 545, 85.4],
  [[4,4,8,8], 546, 95.6],
  [[3,6,10,12], 547, 92.9],
  [[1,2,4,13], 548, 93.6],
  [[2,4,5,13], 549, 94.7],
  [[2,7,8,8], 550, 92.6],
  [[1,2,12,13], 551, 95.9],
  [[2,3,4,12], 552, 94.2],
  [[3,4,9,12], 553, 94.5],
  [[9,11,13,13], 554, 92],
  [[2,2,4,10], 555, 94.1],
  [[2,8,12,13], 556, 89.4],
  [[3,4,4,12], 557, 90.4],
  [[2,4,4,11], 558, 84.5],
  [[2,3,5,6], 559, 95],
  [[2,6,11,13], 560, 89.7],
  [[3,9,12,12], 561, 90.7],
  [[5,6,10,10], 562, 86.9],
  [[1,3,8,12], 563, 96.6],
  [[2,6,8,11], 564, 93.3],
  [[1,4,10,11], 565, 95],
  [[1,9,11,11], 566, 89.7],
  [[1,4,9,12], 567, 95.9],
  [[4,8,10,11], 568, 90.4],
  [[2,2,2,10], 569, 94.1],
  [[3,6,12,12], 570, 93],
  [[1,2,9,12], 571, 92.4],
  [[3,3,4,12], 572, 95],
  [[4,5,7,8], 573, 95.6],
  [[4,7,9,10], 574, 90.5],
  [[4,4,4,5], 575, 84.9],
  [[5,6,7,8], 576, 93.5],
  [[1,6,9,13], 577, 90.6],
  [[2,6,8,10], 578, 93.2],
  [[3,3,4,7], 579, 90.2],
  [[6,6,10,12], 580, 93.8],
  [[8,9,11,13], 581, 90.7],
  [[3,4,4,9], 582, 90.9],
  [[3,5,8,11], 583, 89.6],
  [[6,6,7,10], 584, 84.2],
  [[6,6,9,12], 585, 92.6],
  [[1,3,5,11], 586, 93.2],
  [[1,5,6,10], 587, 91.5],
  [[3,6,6,9], 588, 96.2],
  [[1,2,2,5], 589, 94.3],
  [[1,2,4,11], 590, 91.9],
  [[2,5,5,11], 591, 82.9],
  [[3,3,8,9], 592, 88.7],
  [[3,6,10,10], 593, 85.3],
  [[5,6,6,6], 594, 87.5],
  [[8,11,12,12], 595, 77.5],
  [[1,4,8,11], 596, 95.4],
  [[5,8,8,9], 597, 87],
  [[2,2,9,11], 598, 91.5],
  [[2,7,7,11], 599, 86.6],
  [[1,4,4,9], 600, 94.1],
  [[1,4,4,10], 601, 92],
  [[4,5,10,11], 602, 88.1],
  [[1,2,6,9], 603, 94.3],
  [[3,4,12,13], 604, 93.2],
  [[3,9,10,10], 605, 84.7],
  [[3,12,12,12], 606, 90.9],
  [[3,7,12,12], 607, 91.2],
  [[4,5,8,9], 608, 88.9],
  [[10,12,13,13], 609, 94.2],
  [[2,2,6,12], 610, 94.1],
  [[3,4,5,5], 611, 93.9],
  [[6,7,8,10], 612, 91.6],
  [[2,2,4,8], 613, 95.8],
  [[3,6,7,9], 614, 92.8],
  [[2,4,6,10], 615, 93.8],
  [[3,4,7,9], 616, 93.1],
  [[4,8,9,10], 617, 88.8],
  [[5,6,10,11], 618, 90.3],
  [[8,10,13,13], 619, 92.5],
  [[2,5,6,13], 620, 91.4],
  [[3,12,12,13], 621, 92.4],
  [[4,6,8,9], 622, 93.3],
  [[2,3,5,11], 623, 94.8],
  [[7,8,11,13], 624, 90.1],
  [[2,3,3,6], 625, 96.2],
  [[5,8,8,13], 626, 92.4],
  [[2,2,3,3], 627, 93.3],
  [[1,4,6,11], 628, 92.5],
  [[3,9,12,13], 629, 89.7],
  [[1,2,5,9], 630, 95],
  [[2,7,8,11], 631, 94.8],
  [[1,3,6,9], 632, 93.1],
  [[3,4,10,12], 633, 92.4],
  [[3,7,10,11], 634, 90.5],
  [[4,10,12,12], 635, 92],
  [[4,4,6,12], 636, 93.9],
  [[10,11,12,13], 637, 95.8],
  [[2,5,6,7], 638, 92.3],
  [[3,5,8,8], 639, 92.1],
  [[2,2,3,7], 640, 88.1],
  [[2,8,8,9], 641, 90.2],
  [[8,10,10,12], 642, 94.3],
  [[4,8,8,9], 643, 92.3],
  [[1,5,9,10], 644, 93.5],
  [[2,3,4,8], 645, 92.5],
  [[4,7,9,12], 646, 94.9],
  [[1,1,7,10], 647, 85.1],
  [[2,4,8,8], 648, 93.9],
  [[2,7,11,12], 649, 91.5],
  [[2,4,8,12], 650, 93.8],
  [[1,3,12,12], 651, 85.5],
  [[2,4,9,13], 652, 93.6],
  [[4,5,9,10], 653, 90.6],
  [[1,3,4,13], 654, 94.1],
  [[3,7,8,12], 655, 95],
  [[1,4,5,11], 656, 90.6],
  [[1,4,9,11], 657, 94.4],
  [[2,7,9,10], 658, 93.9],
  [[2,8,9,13], 659, 90.1],
  [[4,4,10,12], 660, 90.6],
  [[3,4,9,11], 661, 89.8],
  [[4,6,8,12], 662, 94.2],
  [[1,5,5,13], 663, 93.3],
  [[3,6,9,10], 664, 92.4],
  [[2,8,9,10], 665, 88.8],
  [[3,5,6,6], 666, 92.2],
  [[5,8,11,13], 667, 88.8],
  [[6,8,8,10], 668, 91],
  [[2,4,8,11], 669, 92.7],
  [[5,5,8,8], 670, 84.8],
  [[5,5,8,9], 671, 89.6],
  [[9,10,12,13], 672, 93.5],
  [[1,3,6,13], 673, 91.8],
  [[2,2,6,10], 674, 95.1],
  [[1,8,11,13], 675, 88.2],
  [[2,2,4,11], 676, 91.5],
  [[5,8,9,11], 677, 89.9],
  [[3,4,5,10], 678, 90.3],
  [[1,2,8,9], 679, 93.4],
  [[1,6,11,12], 680, 88.8],
  [[2,5,10,11], 681, 94.1],
  [[5,6,9,10], 682, 90.8],
  [[1,3,4,9], 683, 94.5],
  [[3,4,7,10], 684, 93.3],
  [[6,6,7,9], 685, 90.7],
  [[6,8,8,11], 686, 87.7],
  [[2,4,4,4], 687, 94.6],
  [[2,9,10,11], 688, 88.7],
  [[4,4,8,11], 689, 87],
  [[4,4,4,9], 690, 88.3],
  [[6,8,10,13], 691, 86.6],
  [[2,8,8,11], 692, 84],
  [[4,7,8,9], 693, 92.1],
  [[1,6,12,13], 694, 89.4],
  [[4,4,7,12], 695, 89.4],
  [[6,6,8,9], 696, 90.3],
  [[1,2,2,7], 697, 91.7],
  [[1,2,6,13], 698, 90.6],
  [[2,3,3,7], 699, 92.1],
  [[2,4,7,10], 700, 91.2],
  [[2,9,12,13], 701, 90.6],
  [[6,6,9,11], 702, 88.8],
  [[3,3,7,11], 703, 92.2],
  [[3,3,8,12], 704, 91.7],
  [[1,4,9,10], 705, 93.2],
  [[3,6,8,9], 706, 93.8],
  [[4,4,6,11], 707, 86.3],
  [[1,6,10,13], 708, 87.6],
  [[1,3,4,10], 709, 92.9],
  [[2,9,10,13], 710, 90.2],
  [[5,6,10,13], 711, 91.5],
  [[3,11,12,12], 712, 90.8],
  [[6,6,8,11], 713, 82.9],
  [[7,8,8,11], 714, 80.6],
  [[1,2,7,8], 715, 94.3],
  [[1,11,13,13], 716, 91.3],
  [[1,4,6,7], 717, 87.3],
  [[2,10,11,13], 718, 89.5],
  [[5,7,8,8], 719, 82.7],
  [[2,2,3,13], 720, 87.6],
  [[2,3,10,13], 721, 93.4],
  [[2,4,6,6], 722, 94.1],
  [[4,5,6,7], 723, 90.3],
  [[4,5,8,12], 724, 93.3],
  [[3,6,7,12], 725, 90],
  [[3,7,7,13], 726, 93.4],
  [[1,2,9,13], 727, 93.3],
  [[2,2,4,13], 728, 91.1],
  [[4,4,9,11], 729, 82.5],
  [[1,2,3,11], 730, 95.7],
  [[2,4,6,9], 731, 91.8],
  [[2,8,11,12], 732, 88.3],
  [[4,4,4,11], 733, 86],
  [[1,2,3,3], 734, 95.5],
  [[4,5,9,13], 735, 89.3],
  [[4,6,10,12], 736, 93.8],
  [[2,4,9,9], 737, 90],
  [[2,6,6,10], 738, 94.1],
  [[1,2,5,13], 739, 94.3],
  [[6,8,9,13], 740, 93.9],
  [[2,9,11,11], 741, 89.3],
  [[1,3,9,13], 742, 93.7],
  [[2,2,8,10], 743, 94.3],
  [[2,4,7,11], 744, 92.5],
  [[2,6,7,8], 745, 89.6],
  [[1,3,4,7], 746, 95],
  [[4,8,9,11], 747, 93],
  [[6,6,8,10], 748, 90.1],
  [[5,5,9,10], 749, 86.9],
  [[2,3,7,11], 750, 91.7],
  [[2,8,9,11], 751, 90.5],
  [[2,4,10,13], 752, 88.9],
  [[1,3,8,8], 753, 86.5],
  [[3,9,9,10], 754, 86.7],
  [[4,11,12,13], 755, 91.2],
  [[1,2,6,11], 756, 90],
  [[2,5,7,10], 757, 92.2],
  [[3,4,7,7], 758, 94],
  [[6,8,12,12], 759, 91.5],
  [[2,3,5,9], 760, 92],
  [[4,4,8,10], 761, 91.4],
  [[3,7,10,13], 762, 88.2],
  [[4,5,8,8], 763, 86.4],
  [[3,4,4,5], 764, 91.1],
  [[3,5,9,12], 765, 90],
  [[4,8,8,12], 766, 94.4],
  [[4,12,12,12], 767, 86],
  [[2,2,5,6], 768, 88.6],
  [[9,10,11,13], 769, 89.7],
  [[2,3,4,13], 770, 90.9],
  [[3,10,11,12], 771, 89.4],
  [[4,4,8,13], 772, 86.7],
  [[5,6,6,10], 773, 88.9],
  [[1,1,3,10], 774, 88.1],
  [[1,2,4,5], 775, 90.4],
  [[1,4,5,10], 776, 91.2],
  [[2,5,8,13], 777, 93],
  [[3,5,6,9], 778, 92.5],
  [[7,8,10,13], 779, 92.1],
  [[6,6,8,13], 780, 83.8],
  [[3,9,10,12], 781, 90.2],
  [[1,2,4,9], 782, 90.8],
  [[1,3,3,10], 783, 89.6],
  [[1,5,5,9], 784, 88.4],
  [[1,4,6,9], 785, 86.1],
  [[2,3,9,9], 786, 90.5],
  [[4,4,5,10], 787, 86.3],
  [[6,6,6,12], 788, 89.5],
  [[1,3,5,10], 789, 93.2],
  [[2,11,12,13], 790, 89.8],
  [[2,2,5,7], 791, 88.9],
  [[8,8,9,13], 792, 81.2],
  [[2,2,3,6], 793, 91.6],
  [[3,4,7,11], 794, 87.3],
  [[3,5,6,7], 795, 89.5],
  [[4,5,5,9], 796, 91.3],
  [[4,7,10,10], 797, 83.9],
  [[3,6,12,13], 798, 86.3],
  [[5,5,6,7], 799, 90.8],
  [[6,8,11,13], 800, 86.3],
  [[1,5,9,11], 801, 93.1],
  [[2,10,11,11], 802, 86.4],
  [[7,12,12,13], 803, 82.6],
  [[5,10,10,12], 804, 86.7],
  [[1,5,6,8], 805, 90],
  [[2,2,3,11], 806, 86.1],
  [[2,2,5,11], 807, 87.4],
  [[2,5,8,9], 808, 92.5],
  [[2,3,4,11], 809, 88.5],
  [[2,3,6,10], 810, 92.2],
  [[1,3,5,7], 811, 90],
  [[1,5,10,13], 812, 88.6],
  [[5,7,8,9], 813, 88.9],
  [[5,11,12,12], 814, 82.8],
  [[8,8,8,13], 815, 84.7],
  [[3,3,6,11], 816, 90.2],
  [[3,7,8,9], 817, 86.9],
  [[2,8,8,10], 818, 92.8],
  [[4,7,7,11], 819, 87.5],
  [[2,3,8,12], 820, 93.2],
  [[3,5,5,9], 821, 83.3],
  [[5,6,7,12], 822, 84.6],
  [[2,3,4,4], 823, 94],
  [[3,3,3,9], 824, 84.5],
  [[1,2,7,9], 825, 93.3],
  [[1,9,11,13], 826, 88],
  [[2,2,6,8], 827, 95.5],
  [[5,8,9,12], 828, 92.3],
  [[1,1,4,10], 829, 85.6],
  [[4,5,10,13], 830, 91.1],
  [[2,3,3,9], 831, 93.2],
  [[3,3,4,9], 832, 92.1],
  [[3,4,6,10], 833, 89.8],
  [[3,4,6,12], 834, 93.3],
  [[3,7,7,10], 835, 89],
  [[3,9,11,12], 836, 90.1],
  [[2,4,4,7], 837, 89.4],
  [[3,4,5,9], 838, 84.9],
  [[4,5,7,12], 839, 87.5],
  [[2,7,9,13], 840, 87.2],
  [[5,9,9,11], 841, 89.5],
  [[6,6,6,8], 842, 91.4],
  [[1,7,12,12], 843, 80.6],
  [[1,6,9,10], 844, 91.8],
  [[2,5,6,10], 845, 88],
  [[3,8,9,12], 846, 90.2],
  [[2,3,6,11], 847, 90.2],
  [[2,4,5,9], 848, 86.3],
  [[4,7,11,12], 849, 86.3],
  [[2,2,4,9], 850, 90.5],
  [[2,6,8,8], 851, 92.5],
  [[4,5,5,7], 852, 82.4],
  [[2,3,8,11], 853, 92.7],
  [[4,7,8,13], 854, 90.7],
  [[6,6,8,12], 855, 90.8],
  [[5,6,8,9], 856, 89.9],
  [[3,3,5,9], 857, 87],
  [[4,5,7,11], 858, 87.3],
  [[4,9,12,12], 859, 89.4],
  [[3,3,6,9], 860, 94.2],
  [[3,5,9,13], 861, 91.3],
  [[3,7,8,13], 862, 84],
  [[4,4,5,7], 863, 85.1],
  [[1,5,5,11], 864, 88],
  [[2,4,6,13], 865, 87.2],
  [[6,7,9,12], 866, 86.8],
  [[1,5,6,13], 867, 90.3],
  [[3,8,8,11], 868, 89.5],
  [[2,3,4,10], 869, 91.9],
  [[6,6,8,8], 870, 86],
  [[4,9,9,10], 871, 89.9],
  [[3,3,7,9], 872, 90.6],
  [[1,7,9,10], 873, 86.8],
  [[2,3,9,13], 874, 87.5],
  [[3,3,3,5], 875, 85.7],
  [[5,6,9,12], 876, 87.2],
  [[6,9,10,11], 877, 91.4],
  [[2,4,5,11], 878, 87.6],
  [[1,2,5,10], 879, 91.7],
  [[2,2,2,5], 880, 78.7],
  [[6,12,13,13], 881, 87.3],
  [[3,3,6,10], 882, 86.4],
  [[3,4,8,11], 883, 87.2],
  [[4,4,6,13], 884, 82.6],
  [[4,6,7,10], 885, 86.5],
  [[6,11,11,12], 886, 86.4],
  [[3,6,9,11], 887, 86.8],
  [[5,7,9,13], 888, 90.9],
  [[2,4,12,12], 889, 85.7],
  [[4,9,11,12], 890, 89],
  [[7,8,9,13], 891, 84],
  [[2,6,12,12], 892, 89],
  [[3,4,5,6], 893, 84],
  [[6,10,12,12], 894, 88.8],
  [[5,5,5,9], 895, 87.6],
  [[5,5,6,11], 896, 87.1],
  [[6,8,9,9], 897, 86.2],
  [[3,3,6,13], 898, 86.4],
  [[6,8,9,11], 899, 84.4],
  [[1,3,3,11], 900, 88.2],
  [[4,5,6,10], 901, 90.3],
  [[1,2,4,7], 902, 89.1],
  [[2,5,8,11], 903, 85.9],
  [[3,4,4,13], 904, 88.8],
  [[6,7,8,9], 905, 84.5],
  [[1,11,11,13], 906, 87.7],
  [[1,8,10,11], 907, 86.9],
  [[2,3,6,9], 908, 93.1],
  [[1,3,5,9], 909, 90.6],
  [[3,3,7,12], 910, 84.5],
  [[4,5,7,9], 911, 86.7],
  [[1,2,8,13], 912, 91.3],
  [[4,6,6,9], 913, 87.6],
  [[1,4,4,8], 914, 89.7],
  [[1,5,10,11], 915, 86.3],
  [[3,4,6,11], 916, 88.9],
  [[2,4,8,9], 917, 84],
  [[1,4,5,13], 918, 87.7],
  [[2,2,7,12], 919, 83.2],
  [[3,3,6,7], 920, 88.7],
  [[1,5,9,13], 921, 84.9],
  [[5,6,7,13], 922, 86.4],
  [[5,5,8,10], 923, 81.3],
  [[2,4,6,12], 924, 94.5],
  [[6,7,8,11], 925, 83.9],
  [[7,9,9,13], 926, 88],
  [[3,6,9,12], 927, 92.7],
  [[6,9,12,13], 928, 88.3],
  [[4,7,9,13], 929, 84.3],
  [[5,6,8,12], 930, 87.9],
  [[2,4,6,7], 931, 90.1],
  [[2,5,10,10], 932, 78.3],
  [[6,6,7,12], 933, 83.8],
  [[6,9,9,11], 934, 82.4],
  [[5,8,11,12], 935, 86.9],
  [[5,6,8,10], 936, 87],
  [[6,11,12,13], 937, 80.1],
  [[2,2,8,8], 938, 91.4],
  [[2,7,12,13], 939, 80.4],
  [[2,6,8,12], 940, 94],
  [[3,4,9,13], 941, 79.6],
  [[4,5,10,12], 942, 86.2],
  [[1,2,7,11], 943, 88.1],
  [[4,5,6,8], 944, 87.3],
  [[6,10,12,13], 945, 82.5],
  [[1,3,9,9], 946, 85.2],
  [[1,4,4,11], 947, 86.7],
  [[2,3,9,10], 948, 90],
  [[1,2,3,13], 949, 91.7],
  [[1,6,6,6], 950, 85.6],
  [[1,2,2,9], 951, 82.4],
  [[1,3,6,11], 952, 88.1],
  [[5,10,12,13], 953, 83.5],
  [[2,3,6,6], 954, 91.9],
  [[6,7,10,12], 955, 85.2],
  [[7,8,8,12], 956, 83.6],
  [[3,4,6,8], 957, 90.7],
  [[1,7,9,11], 958, 85.1],
  [[2,3,6,13], 959, 90],
  [[2,2,5,12], 960, 84.8],
  [[2,6,8,13], 961, 87.2],
  [[8,8,10,12], 962, 78.7],
  [[1,3,8,13], 963, 90.4],
  [[4,4,7,10], 964, 75.2],
  [[1,7,10,13], 965, 83.7],
  [[1,9,10,13], 966, 83],
  [[3,3,4,11], 967, 88.6],
  [[2,5,7,7], 968, 82.9],
  [[3,9,10,13], 969, 83],
  [[2,3,4,7], 970, 86.7],
  [[4,4,8,12], 971, 92],
  [[1,2,6,10], 972, 86.8],
  [[1,5,12,12], 973, 81.3],
  [[5,6,6,8], 974, 81.5],
  [[7,7,8,11], 975, 80.4],
  [[1,3,7,10], 976, 86.5],
  [[3,3,9,12], 977, 87],
  [[3,5,7,10], 978, 84.5],
  [[4,10,12,13], 979, 81.5],
  [[2,3,10,12], 980, 86.4],
  [[3,4,6,6], 981, 90.5],
  [[5,8,8,8], 982, 80.2],
  [[6,8,8,12], 983, 88.1],
  [[2,3,4,9], 984, 88.2],
  [[2,6,7,11], 985, 82.6],
  [[5,9,12,12], 986, 83],
  [[1,2,7,12], 987, 77.9],
  [[2,4,5,6], 988, 91],
  [[5,5,8,13], 989, 80.8],
  [[2,3,3,10], 990, 84.6],
  [[3,4,8,12], 991, 87.7],
  [[2,4,6,11], 992, 85.1],
  [[2,2,8,9], 993, 87],
  [[1,5,6,7], 994, 88.7],
  [[5,8,10,11], 995, 87.1],
  [[4,4,9,12], 996, 78.3],
  [[2,5,6,6], 997, 78],
  [[2,4,9,12], 998, 87.2],
  [[4,8,11,13], 999, 82.4],
  [[4,9,10,13], 1000, 82.4],
  [[3,3,5,12], 1001, 86.7],
  [[2,4,4,6], 1002, 90.2],
  [[2,4,6,8], 1003, 93.3],
  [[3,4,6,9], 1004, 82.5],
  [[2,3,4,5], 1005, 84.4],
  [[3,3,6,12], 1006, 86.9],
  [[3,6,7,13], 1007, 82.5],
  [[1,4,7,7], 1008, 85.5],
  [[4,4,5,11], 1009, 85],
  [[6,7,9,9], 1010, 80.4],
  [[7,8,10,10], 1011, 79.1],
  [[4,8,9,13], 1012, 82.7],
  [[1,3,4,8], 1013, 89.6],
  [[8,9,9,12], 1014, 82.4],
  [[3,7,8,11], 1015, 83],
  [[4,6,7,12], 1016, 81.4],
  [[1,6,7,9], 1017, 84.4],
  [[3,7,9,12], 1018, 85.9],
  [[4,5,6,13], 1019, 78],
  [[3,3,5,13], 1020, 84.9],
  [[2,3,5,7], 1021, 88.9],
  [[4,6,8,13], 1022, 81],
  [[2,7,9,11], 1023, 83.5],
  [[1,3,7,12], 1024, 85.4],
  [[3,5,7,9], 1025, 86.2],
  [[2,6,10,13], 1026, 84.6],
  [[6,8,9,12], 1027, 86.6],
  [[1,5,7,9], 1028, 84.4],
  [[1,3,7,7], 1029, 85.2],
  [[2,9,11,13], 1030, 82.2],
  [[3,7,9,11], 1031, 88.1],
  [[4,8,8,10], 1032, 85.7],
  [[1,4,8,9], 1033, 89],
  [[2,5,11,12], 1034, 77.1],
  [[2,3,7,13], 1035, 86.3],
  [[3,5,10,13], 1036, 82.3],
  [[3,5,6,10], 1037, 85.8],
  [[4,5,5,10], 1038, 81.2],
  [[7,8,9,10], 1039, 79.8],
  [[2,5,8,10], 1040, 82.9],
  [[4,6,6,12], 1041, 86],
  [[5,8,10,12], 1042, 84.3],
  [[3,3,3,11], 1043, 78],
  [[5,5,8,12], 1044, 79.5],
  [[1,3,3,6], 1045, 87.2],
  [[2,5,7,13], 1046, 83.8],
  [[1,5,8,11], 1047, 89.2],
  [[2,3,5,13], 1048, 85.5],
  [[3,4,8,9], 1049, 88.1],
  [[2,5,5,7], 1050, 82],
  [[4,10,11,13], 1051, 76.2],
  [[2,6,6,7], 1052, 78.4],
  [[7,10,10,12], 1053, 78],
  [[2,5,7,11], 1054, 82.4],
  [[4,4,6,9], 1055, 77.4],
  [[6,9,10,12], 1056, 80.5],
  [[6,9,9,12], 1057, 87],
  [[2,3,6,12], 1058, 91],
  [[2,4,4,5], 1059, 82.1],
  [[2,4,4,10], 1060, 89.6],
  [[3,3,3,4], 1061, 82.4],
  [[2,2,2,7], 1062, 73.3],
  [[4,9,10,11], 1063, 76.8],
  [[7,9,10,11], 1064, 76.9],
  [[1,4,5,7], 1065, 87.9],
  [[3,4,9,9], 1066, 84.2],
  [[3,3,6,8], 1067, 74.6],
  [[4,4,7,8], 1068, 83.8],
  [[3,5,11,12], 1069, 79.9],
  [[4,4,6,10], 1070, 87.5],
  [[4,6,9,13], 1071, 85.5],
  [[3,5,6,11], 1072, 82.5],
  [[1,5,8,13], 1073, 80.1],
  [[3,3,9,13], 1074, 74.6],
  [[7,7,9,10], 1075, 75.8],
  [[2,4,8,13], 1076, 82.2],
  [[4,4,6,8], 1077, 84.2],
  [[2,4,5,7], 1078, 78.4],
  [[1,4,7,9], 1079, 82.2],
  [[4,7,10,12], 1080, 79.8],
  [[4,5,8,13], 1081, 78],
  [[5,6,10,12], 1082, 75.8],
  [[6,9,11,13], 1083, 72.5],
  [[5,7,7,9], 1084, 74.2],
  [[1,4,5,9], 1085, 81.9],
  [[5,7,11,13], 1086, 70.8],
  [[3,3,5,10], 1087, 82.9],
  [[4,8,12,12], 1088, 85.6],
  [[2,3,3,3], 1089, 82.1],
  [[2,5,10,13], 1090, 82.1],
  [[1,4,6,6], 1091, 80],
  [[2,3,8,8], 1092, 80.4],
  [[6,9,11,12], 1093, 75.9],
  [[1,1,6,9], 1094, 81],
  [[5,9,10,13], 1095, 78],
  [[1,5,6,11], 1096, 81],
  [[4,4,5,12], 1097, 79],
  [[3,5,6,13], 1098, 76],
  [[1,4,5,8], 1099, 82.7],
  [[5,5,7,10], 1100, 73.8],
  [[2,2,2,9], 1101, 76.6],
  [[5,7,10,10], 1102, 76.5],
  [[2,3,5,10], 1103, 80.2],
  [[2,8,10,13], 1104, 80.9],
  [[6,7,7,10], 1105, 73],
  [[2,7,10,11], 1106, 78.9],
  [[3,5,7,8], 1107, 85.4],
  [[6,8,11,12], 1108, 77.9],
  [[1,3,6,10], 1109, 82.1],
  [[4,10,10,12], 1110, 78.4],
  [[7,10,11,13], 1111, 73.3],
  [[4,5,8,10], 1112, 75.9],
  [[3,8,9,11], 1113, 80.1],
  [[6,12,12,12], 1114, 76.6],
  [[2,10,12,13], 1115, 81.4],
  [[6,7,10,10], 1116, 70.8],
  [[2,3,7,8], 1117, 80.2],
  [[3,5,9,9], 1118, 79.4],
  [[2,2,5,9], 1119, 74.3],
  [[2,4,7,9], 1120, 80.6],
  [[2,3,8,9], 1121, 81.3],
  [[3,5,5,11], 1122, 79],
  [[3,3,9,11], 1123, 79.1],
  [[5,7,9,11], 1124, 71.1],
  [[1,3,7,9], 1125, 80.4],
  [[2,4,9,10], 1126, 79.3],
  [[3,5,12,12], 1127, 67.2],
  [[3,3,8,10], 1128, 80.3],
  [[4,4,5,13], 1129, 73.3],
  [[3,4,4,11], 1130, 76.4],
  [[4,5,8,11], 1131, 73.8],
  [[3,4,4,10], 1132, 77.1],
  [[2,6,12,13], 1133, 78.6],
  [[3,6,11,13], 1134, 73.2],
  [[1,3,5,6], 1135, 86.3],
  [[3,3,4,13], 1136, 76.8],
  [[4,6,9,12], 1137, 77.8],
  [[6,10,10,13], 1138, 69.1],
  [[2,5,9,10], 1139, 78.1],
  [[5,5,9,11], 1140, 71.1],
  [[3,4,7,12], 1141, 82.4],
  [[2,6,9,12], 1142, 82.7],
  [[5,6,6,12], 1143, 80.7],
  [[2,5,9,11], 1144, 76.5],
  [[5,9,9,12], 1145, 75.7],
  [[4,4,4,10], 1146, 76.9],
  [[3,4,10,10], 1147, 75.5],
  [[2,2,5,10], 1148, 78.6],
  [[3,3,9,10], 1149, 78.1],
  [[4,7,8,12], 1150, 79.4],
  [[7,9,12,12], 1151, 64.2],
  [[2,2,7,7], 1152, 69.8],
  [[3,6,8,13], 1153, 81.3],
  [[2,2,3,4], 1154, 77.4],
  [[5,7,8,10], 1155, 71.2],
  [[1,5,11,12], 1156, 71],
  [[4,6,8,10], 1157, 76.7],
  [[2,4,10,11], 1158, 79.2],
  [[3,6,6,13], 1159, 72.8],
  [[3,6,8,12], 1160, 80.5],
  [[1,4,4,6], 1161, 79.6],
  [[2,5,8,8], 1162, 71],
  [[7,7,7,12], 1163, 65.2],
  [[4,5,7,13], 1164, 72.8],
  [[5,5,5,12], 1165, 67.4],
  [[2,6,11,12], 1166, 77.7],
  [[2,3,8,10], 1167, 82.2],
  [[1,5,5,10], 1168, 71.2],
  [[2,5,5,9], 1169, 78.5],
  [[5,7,12,12], 1170, 66],
  [[4,7,8,11], 1171, 69],
  [[3,3,8,13], 1172, 69.7],
  [[1,3,12,13], 1173, 75.6],
  [[1,3,8,10], 1174, 71],
  [[2,3,6,7], 1175, 80.8],
  [[2,2,6,7], 1176, 72.5],
  [[5,6,9,13], 1177, 69],
  [[6,10,11,12], 1178, 69.7],
  [[4,9,9,12], 1179, 71.8],
  [[2,6,6,9], 1180, 72.8],
  [[1,3,11,12], 1181, 75.6],
  [[3,10,11,13], 1182, 71.2],
  [[1,4,10,12], 1183, 72.1],
  [[5,5,6,8], 1184, 78.1],
  [[6,8,9,10], 1185, 71.2],
  [[2,6,10,11], 1186, 73.1],
  [[3,9,9,13], 1187, 67.2],
  [[2,4,4,9], 1188, 73.4],
  [[10,12,12,12], 1189, 64.1],
  [[2,3,7,10], 1190, 76.9],
  [[2,7,10,10], 1191, 68.1],
  [[8,8,8,11], 1192, 63.5],
  [[6,6,9,10], 1193, 69.8],
  [[2,3,7,7], 1194, 76.5],
  [[6,6,6,10], 1195, 66],
  [[5,7,7,10], 1196, 68],
  [[2,2,9,12], 1197, 72.9],
  [[3,6,8,10], 1198, 66.6],
  [[3,5,7,12], 1199, 71],
  [[3,5,8,9], 1200, 75.8],
  [[3,9,9,11], 1201, 70.5],
  [[2,8,10,12], 1202, 79.8],
  [[3,8,9,13], 1203, 73.4],
  [[9,9,9,12], 1204, 63.8],
  [[3,4,8,13], 1205, 70],
  [[2,6,7,10], 1206, 69.8],
  [[2,6,9,10], 1207, 69.7],
  [[4,5,6,9], 1208, 75.3],
  [[8,10,12,13], 1209, 67.3],
  [[2,6,8,9], 1210, 72.4],
  [[3,5,12,13], 1211, 67.9],
  [[2,4,7,8], 1212, 76.5],
  [[4,8,9,12], 1213, 72.5],
  [[3,5,9,10], 1214, 68.1],
  [[2,3,10,10], 1215, 69.5],
  [[2,2,4,12], 1216, 75.1],
  [[2,2,9,10], 1217, 65.3],
  [[2,7,10,12], 1218, 70.2],
  [[2,2,4,4], 1219, 72],
  [[2,3,11,11], 1220, 68.3],
  [[1,3,3,8], 1221, 74],
  [[6,8,8,9], 1222, 63],
  [[8,10,12,12], 1223, 63.6],
  [[10,10,10,12], 1224, 61.5],
  [[2,3,9,12], 1225, 67.3],
  [[6,8,10,11], 1226, 64.6],
  [[7,8,8,10], 1227, 61.2],
  [[1,5,7,10], 1228, 69.5],
  [[3,5,10,11], 1229, 69.5],
  [[5,9,12,13], 1230, 64.4],
  [[1,3,8,11], 1231, 73.4],
  [[2,7,12,12], 1232, 62.8],
  [[1,2,8,10], 1233, 67.7],
  [[9,11,12,12], 1234, 59.5],
  [[1,6,10,12], 1235, 65.8],
  [[4,4,8,9], 1236, 69.6],
  [[2,3,3,5], 1237, 69.5],
  [[3,6,9,13], 1238, 68.9],
  [[3,3,7,8], 1239, 68.3],
  [[3,5,7,11], 1240, 64],
  [[2,3,5,8], 1241, 72.9],
  [[4,5,7,10], 1242, 63.6],
  [[5,7,10,13], 1243, 61.6],
  [[2,9,10,10], 1244, 60.6],
  [[2,4,5,10], 1245, 67],
  [[2,3,6,8], 1246, 75.3],
  [[5,9,11,13], 1247, 61.5],
  [[3,4,5,13], 1248, 65.6],
  [[1,5,9,12], 1249, 62.6],
  [[3,4,4,4], 1250, 67.3],
  [[5,7,9,10], 1251, 61],
  [[6,6,7,11], 1252, 58],
  [[2,5,10,12], 1253, 63.7],
  [[4,10,11,12], 1254, 62.9],
  [[2,4,5,5], 1255, 60.4],
  [[2,2,5,8], 1256, 63.5],
  [[8,8,9,12], 1257, 56.7],
  [[3,4,7,8], 1258, 61.1],
  [[5,6,6,9], 1259, 59.2],
  [[3,5,10,10], 1260, 54.3],
  [[2,2,6,11], 1261, 62.2],
  [[4,9,10,12], 1262, 61.7],
  [[8,9,11,11], 1263, 58],
  [[3,9,11,13], 1264, 57.6],
  [[4,7,8,10], 1265, 62.9],
  [[5,6,7,9], 1266, 60.1],
  [[2,6,9,9], 1267, 58],
  [[2,3,13,13], 1268, 58.4],
  [[1,7,12,13], 1269, 56.3],
  [[1,4,9,13], 1270, 61.1],
  [[4,10,10,11], 1271, 54.8],
  [[3,4,5,11], 1272, 63.3],
  [[3,3,6,6], 1273, 58],
  [[6,6,9,13], 1274, 53.8],
  [[4,5,9,12], 1275, 60.9],
  [[2,3,7,9], 1276, 57.6],
  [[4,4,7,13], 1277, 53.8],
  [[2,2,7,10], 1278, 53.4],
  [[2,5,12,13], 1279, 58],
  [[1,4,6,10], 1280, 56.3],
  [[3,6,7,10], 1281, 57.4],
  [[1,2,7,7], 1282, 55],
  [[2,5,8,12], 1283, 54.6],
  [[3,8,10,12], 1284, 53.6],
  [[6,7,11,11], 1285, 46.4],
  [[2,2,3,10], 1286, 54.9],
  [[2,5,7,9], 1287, 52.7],
  [[2,4,7,7], 1288, 50.7],
  [[2,2,6,9], 1289, 52.1],
  [[7,9,11,12], 1290, 50],
  [[4,7,9,11], 1291, 51.4],
  [[2,2,3,5], 1292, 51.5],
  [[5,5,8,11], 1293, 45.8],
  [[3,6,6,10], 1294, 50.3],
  [[7,8,9,12], 1295, 48.7],
  [[1,5,11,11], 1296, 43.3],
  [[5,10,10,11], 1297, 41.3],
  [[1,2,9,11], 1298, 44.9],
  [[1,5,5,5], 1299, 43.6],
  [[4,9,11,11], 1300, 43.3],
  [[5,9,10,11], 1301, 42.7],
  [[1,7,13,13], 1302, 41.7],
  [[6,7,7,11], 1303, 42.4],
  [[3,3,7,7], 1304, 41.2],
  [[5,10,10,13], 1305, 38.5],
  [[3,5,8,13], 1306, 41.9],
  [[8,9,10,12], 1307, 42.5],
  [[2,5,6,9], 1308, 44],
  [[1,6,11,13], 1309, 38.1],
  [[1,3,9,10], 1310, 40.8],
  [[4,6,6,10], 1311, 40.2],
  [[4,4,7,7], 1312, 38.8],
  [[2,2,11,11], 1313, 40.1],
  [[5,7,9,12], 1314, 39.6],
  [[4,5,6,12], 1315, 44.1],
  [[4,6,7,9], 1316, 42],
  [[6,12,12,13], 1317, 37.9],
  [[4,4,10,10], 1318, 39.7],
  [[4,7,11,13], 1319, 37],
  [[4,5,6,11], 1320, 38],
  [[3,5,8,12], 1321, 38],
  [[3,4,6,13], 1322, 40.4],
  [[6,7,8,12], 1323, 40.7],
  [[2,4,11,12], 1324, 39.4],
  [[5,7,10,11], 1325, 35.5],
  [[2,2,13,13], 1326, 37.3],
  [[6,11,12,12], 1327, 36.3],
  [[5,8,9,13], 1328, 34.9],
  [[7,10,12,13], 1329, 37.4],
  [[5,6,8,13], 1330, 36.4],
  [[2,7,8,9], 1331, 39.8],
  [[2,2,6,13], 1332, 33.1],
  [[5,6,9,11], 1333, 33.4],
  [[1,4,7,11], 1334, 35.7],
  [[6,9,9,10], 1335, 31.6],
  [[2,5,7,8], 1336, 32.9],
  [[7,8,8,13], 1337, 29.5],
  [[5,7,7,11], 1338, 27.4],
  [[3,3,7,13], 1339, 27.6],
  [[4,8,8,13], 1340, 29.1],
  [[4,8,8,11], 1341, 30],
  [[3,8,8,10], 1342, 28.9],
  [[2,7,7,10], 1343, 27],
  [[5,5,7,11], 1344, 26.1],
  [[2,3,8,13], 1345, 32],
  [[7,8,10,11], 1346, 29.8],
  [[2,2,10,11], 1347, 30.2],
  [[9,11,12,13], 1348, 27.9],
  [[1,6,6,8], 1349, 29.8],
  [[3,3,8,8], 1350, 30.8],
  [[1,8,12,12], 1351, 29],
  [[3,3,5,7], 1352, 29.2],
  [[2,4,7,12], 1353, 28.1],
  [[2,9,13,13], 1354, 24.9],
  [[3,7,9,13], 1355, 26],
  [[2,4,10,10], 1356, 25.8],
  [[3,6,6,11], 1357, 27.1],
  [[3,5,7,13], 1358, 23.6],
  [[2,5,5,10], 1359, 22.1],
  [[1,4,5,6], 1360, 28.7],
  [[1,3,4,6], 1361, 26.9],
  [[2,3,5,12], 1362, 20.7],
]
